import { FileText, BarChart3, ListChecks, LayoutGrid } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { templates, getTemplateById } from '../../lib/page-templates';

interface PageTemplateModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (components: any[]) => void;
}

const templateIcons: Record<string, React.ReactNode> = {
  empty: <FileText className="w-8 h-8" />,
  analytics: <BarChart3 className="w-8 h-8" />,
  crud: <ListChecks className="w-8 h-8" />,
  kanban: <LayoutGrid className="w-8 h-8" />,
};

export default function PageTemplateModal({
  isOpen,
  onClose,
  onSelect,
}: PageTemplateModalProps) {
  if (!isOpen) return null;

  const handleSelect = (templateId: string) => {
    const componentsWithUniqueIds = getTemplateById(templateId);
    onSelect(componentsWithUniqueIds);
  };

  if (!isOpen) return null;

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-4xl max-h-[90vh] flex flex-col">
        <DialogHeader>
          <DialogTitle>Escolha um Template</DialogTitle>
          <DialogDescription>
            Comece com um template pré-configurado ou crie do zero
          </DialogDescription>
        </DialogHeader>

        {/* Content */}
        <div className="flex-1 overflow-y-auto py-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {templates.map((template) => (
              <Button
                key={template.id}
                onClick={() => handleSelect(template.id)}
                variant="outline"
                className="h-auto flex flex-col items-start p-6 hover:border-primary hover:bg-accent transition-all text-left group"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="text-primary">
                    {templateIcons[template.id]}
                  </div>
                  <h3 className="text-lg font-semibold">
                    {template.name}
                  </h3>
                </div>
                <p className="text-sm text-muted-foreground">{template.description}</p>
                <div className="mt-4 text-xs text-muted-foreground">
                  {template.components.length === 0
                    ? 'Nenhum componente'
                    : `${template.components.length} componente(s) incluído(s)`}
                </div>
              </Button>
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
